var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:_vm.xs ? 'ma-0' : null},[_c('v-col',{attrs:{"cols":"12"}},[_c('DashboardCardTripCalendar',{attrs:{"docs":_vm.docs}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }